import {
  createLazyFileRoute,
  Outlet,
  useNavigate,
} from "@tanstack/react-router";
import { memo } from "react";
import type { KeyBindingMap } from "tinykeys";

import { MainApp } from "@/components/AppMain";
import { AppSidebar } from "@/components/layout/AppSidebar";
import { NotFound } from "@/components/NotFound";
import { SidebarProvider } from "@/components/ui/sidebar";
import { useTinyKeys } from "@/lib/useTinyKeys";
import { useCaptureRouteState } from "@/utils/useNavStack";

export const Route = createLazyFileRoute("/_auth/_app")({
  component: memo(() => {
    useCaptureRouteState();

    return (
      <SidebarProvider>
        <MainApp sidebar={<AppSidebar />}>
          <Outlet />
        </MainApp>
      </SidebarProvider>
    );
  }),
  notFoundComponent: () => (
    <SidebarProvider>
      <MainApp sidebar={<AppSidebar />}>
        <NotFound />
      </MainApp>
    </SidebarProvider>
  ),
});

function useViewKeyboardNavigation() {
  const { views } = Route.useRouteContext();
  const navigate = useNavigate();

  useTinyKeys(
    views.reduce((acc, view, idx) => {
      acc[`${idx + 2}`] = (e: KeyboardEvent) => {
        e.preventDefault();
        e.stopImmediatePropagation();
        navigate({
          to: "/views/$id",
          params: { id: view.id },
        });
      };
      return acc;
    }, {} as KeyBindingMap),
  );
}
